import type { ReactNode } from "react";

import { DynamicIcon } from "@similarweb/icons";
import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface ICardBenchmarkRowProps {
    label: ReactNode;
    formattedValue: ReactNode;
    valueColor?: StrictColor;
    dataAutomation: string;
}

export const CardBenchmarkRow = ({
    label,
    formattedValue,
    valueColor = colorsPalettes.carbon[300],
    dataAutomation,
}: ICardBenchmarkRowProps) => (
    <Flex
        alignItems="center"
        gap="4px"
        data-automation={dataAutomation}
    >
        <DynamicIcon
            iconName="Install"
            color={colorsPalettes.carbon[300]}
            size="xs"
        />
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[300]}
        >
            {label}{" "}
            <Text
                as="span"
                fontVariant="captionTitle"
                color={valueColor}
            >
                {formattedValue}
            </Text>
        </Text>
    </Flex>
);
